export const form = () => {

    const modalClose = document.querySelectorAll('.js-modal-close');
    const forms = document.querySelectorAll('.js-form');

    if (forms) {
      for ( let form of forms) {
        form.addEventListener('submit', e => {
          e.preventDefault();
          let formData = new FormData(form);
          let formAction = form.getAttribute("action");
          let formSuccess = form.dataset.success;
          fetch(formAction, {
              method: "POST",
              body: formData
          }).then(response => response.json()).then(response => {
              if (response.success) {
                  form.reset();
  
                  if( formSuccess ) {
                    document.querySelector('.modal[data-modal='+formSuccess+']').classList.add("modal_open");
                  }
                  
                  console.log('form success');
  
              }
          });
        });
      }
    }


    if ( modalClose ) {
      for (let btn of modalClose ) {
        btn.addEventListener('click',function(){
          btn.closest(".modal").classList.remove("modal_open");
        });
      }
    }
    

}